import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function Journal() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/journal").then((r) => setItems(r.data.items)); }, []);
  return (
    <div data-testid="journal-page">
      <SEO
        title="Journal — Dubai property insights"
        description="Point Penta's research desk on Dubai real estate, off-plan, Golden Visa and market outlook."
        path="/journal"
      />
      <section className="pt-6 pb-14 border-b border-neutral-200">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Journal", path: "/journal" }]} />
          <div className="overline text-[#001588] mb-4">Journal</div>
          <h1 className="font-serif text-5xl lg:text-7xl leading-tight max-w-4xl">The research desk,<br/><span className="italic text-neutral-600">unfiltered.</span></h1>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid md:grid-cols-2 gap-x-10 gap-y-14">
          {items.map((j) => (
            <Link key={j.slug} to={`/journal/${j.slug}`} className="group block" data-testid={`journal-card-${j.slug}`}>
              <div className="pp-hover-zoom aspect-[16/9] mb-5">
                <img src={j.hero_image} alt={j.title} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div className="overline text-[#001588] mb-2">{j.category}</div>
              <h2 className="font-serif text-3xl leading-tight group-hover:text-[#001588] transition-colors">{j.title}</h2>
              <p className="text-neutral-500 mt-3">{j.excerpt}</p>
              <div className="text-xs text-neutral-400 mt-4">
                By {j.author}
                {j.created_at && (
                  <span className="ml-2">
                    · {new Date(j.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}
                  </span>
                )}
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
